import { render, staticRenderFns } from "./ProspectCRTask.vue?vue&type=template&id=2352d471&scoped=true"
import script from "./ProspectCRTask.vue?vue&type=script&lang=js"
export * from "./ProspectCRTask.vue?vue&type=script&lang=js"
import style0 from "./ProspectCRTask.vue?vue&type=style&index=0&id=2352d471&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2352d471",
  null
  
)

export default component.exports